import template from './payment-method.html';

export default template;
